type Source = {
	title: string;
	url: string;
};

const buildSourcesString = (sources: Source[]): string => {
	return sources.map((source, index) => `${index + 1}. ${source.url}`).join('\n\n');
};

export const normalizeCitations = (
	content: string,
	sources: Source[],
): { result: string; sourcesString: string } => {
	const sourcesString = sources ? buildSourcesString(sources) : '';
	const sourceCount = sources?.length ?? 0;

	// Replace all references with the normalized format.
	// Citations with leading zeros (e.g. ^00^, ^01^, ^02^) or exactly ^0^ are 0-based source indices → display as index+1.
	// Otherwise treat as 1-based display number (e.g. ^1^, ^2^).
	const result = content.replace(/\[\^(\d+)\^]/g, (_: string, digits: string) => {
		const num = parseInt(digits, 10);
		const isZeroIndexed = digits === '0' || (digits.length > 1 && digits[0] === '0');
		const displayNum = isZeroIndexed
			? Math.max(1, Math.min(num + 1, sourceCount))
			: Math.max(1, Math.min(num, sourceCount));
		return `[${displayNum}]`;
	});

	return { result, sourcesString };
};
